@let data = section();

<section class="cms-cards tg-section">
    <div class="tg-container">
        <div class="cms-cards__body" [class.cms-cards__body--column]="isColumn()">
            @if (data.titleContent || data.buttonsList.length) {
                <div class="cms-cards__intro">
                    @if (data.titleContent) {
                        <div class="cms-content" [innerHTML]="data.titleContent | trustHtml"></div>
                    }

                    @if (data.buttonsList.length) {
                        <div class="cms-cards__actions">
                            @for (button of data.buttonsList; track button.id) {
                                <cms-btn [config]="button" />
                            }
                        </div>
                    }
                </div>
            }

            <div class="cms-cards__grid" [class.cms-cards__grid--column]="isColumn()">
                @for (card of data.cardItems; track card.id) {
                    <article class="cms-cards__card">
                        <div class="cms-cards__header">
                            @if (card.image?.url) {
                                <cms-image class="cms-cards__media" [media]="card.image" />
                            }
                            @if (card.tagLabel) {
                                <h3 class="cms-cards__title tg-h3">{{ card.tagLabel }}</h3>
                            }
                        </div>
                        @if (card.content) {
                            <div class="cms-content" [innerHTML]="card.content | trustHtml"></div>
                        }
                        @if (card.buttonLink) {
                            <cms-btn class="cms-cards__cta" [config]="card.buttonLink" />
                        }
                    </article>
                }
            </div>
        </div>
    </div>
</section>
